export interface Sizes {
  accordions: {
    S: string;
    M: string;
  };
  button: {
    S: string;
    M: string;
    L: string;
  };
}
export const sizes: Sizes = {
  accordions: {
    S: `4.8rem`,
    M: `8.8rem`,
  },
  button: {
    S: `3.2rem`,
    M: `3.6rem`,
    L: `4rem`,
  },
};
